import { makeStyles, shorthands } from '@fluentui/react-components';

export const useLayoutStyles = makeStyles({
  layer: {
    top: '60px',
    zIndex: '1000',
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.66)',
  },
  previewContainer: {
    width: '100%',
    height: '100%',
    paddingRight: '480px',
    cursor: 'auto',
  },
  spinner: {
    width: '100%',
    height: '100%',
    zIndex: '2',
    position: 'absolute',
  },
});

export const usePreviewBaseStyles = makeStyles({
  previewContainer: {
    width: '100%',
    height: '100%',
    position: 'relative',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    ...shorthands.padding('26px', '20px', '74px', '20px'),
  },
  fadeOut: {
    opacity: 0,
    ...shorthands.transition('all', '0.1s', 'linear'),
  },
});

export const useSequentialNavigatorStyles = makeStyles({
  sequentialNavigatorContainer: {
    position: 'absolute',
    bottom: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '16px',
    color: 'white',
  },
  navigatorStatusContainer: {
    fontFamily: 'Segoe UI',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '16px',
    ...shorthands.margin('0', '12px', '0', '12px'),
  },
  iconButton: {
    fontFamily: 'MsAds MDL2 Assets !important',
    fontSize: '16px',
    lineHeight: '16px',
    backgroundColor: 'transparent',
    ...shorthands.border('none'),
    ...shorthands.padding('0px'),
    color: 'white',
  },
  chevronLeft: {
    '&:before': {
      content: '"\\E76B"',
    },
  },
  chevronRight: {
    '&:before': {
      content: '"\\E76C"',
    },
  },
  disabledIcon: {
    color: 'rgba(255, 255, 255, 0.5)',
  },
});

export const useNonActiveVideoPreviewStyle = makeStyles({
  container: {
    height: '500px',
    maxWidth: '746px',
    width: '100%',
    flexGrow: '1',
  },
  failedIconContainer: {
    color: 'orange',
  },
});

export const usePanelStyle = makeStyles({
  detailPanel: {
    width: '480px',
    top: '60px',
  },
  header: {
    paddingTop: '16px',
  },
  content: {
    ...shorthands.padding('0', '32px'),
  },
  footer: {
    width: '100%',
    ...shorthands.borderTop('1px', 'solid', '#EDEBE9'),
    ...shorthands.padding('8px', '24px'),
  },
  footerButton: {
    display: 'block',
    width: '60px',
    minWidth: '0px',
    ...shorthands.overflow('hidden'),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  navigation: {
    marginLeft: '32px',
  },
});

export const useDetailPanelStyle = makeStyles({
  imageUsage: {
    marginTop: '24px',
    marginLeft: '28px',
  },
});

export const useInfoPaneHeaderStyle = makeStyles({
  detailHeader: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  },
  panelTitle: {
    fontFamily: 'Segoe UI',
    fontWeight: 600,
    fontSize: '20px',
    lineHeight: '27px',
    minWidth: '0px',
    flexGrow: 1,
  },
  buttonBox: {
    display: 'flex',
    alignItems: 'center',
  },
  // iconBox: getSharedIconBoxStyle({ palette }),
  editBox: {
    width: '75px',
    minWidth: '0px',
    marginRight: '8px',
  },
  deleteBox: {
    width: '92px',
    marginRight: '8px',
    minWidth: '0px',
  },
  icon: {
    width: '20px',
    height: '20px',
  },
  headerText: {
    width: '45px',
    textAlign: 'center',
    fontFamily: 'Segoe UI',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '20px',
    // color: palette.neutralPrimary,
    marginLeft: '4px',
    ...shorthands.overflow('hidden'),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  disabledButton: {
    // color: `${palette.neutralTertiary} !important`,
  },
  closeButton: {
    width: '32px',
    height: '32px',
  },
});

export const useInfoItemDefaultStyles = makeStyles({
  contentItem: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Segoe UI',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '19px',
    marginTop: '8px',
  },
  contentName: {
    // color: palette.neutralSecondary,
    marginRight: '8px',
    width: '97px',
  },
  contentValue: {
    // color: palette.neutralPrimary,
    maxWidth: '230px',
    ...shorthands.overflow('hidden'),
    textOverflow: 'ellipsis',
    wordBreak: 'break-all',
    whiteSpace: 'nowrap',
  },
});

export const useItemInfoContentStyles = makeStyles({
  contentBox: {
    width: '100%',
    paddingTop: '10px',
    // background: palette.neutralLighterAlt,
  },
  detailContentWrapper: {
    ...shorthands.overflow('hidden'),
    ...shorthands.borderTop('1px', 'solid', '#EDEBE9'),
    paddingTop: '8px',
  },
  linkContainer: {
    marginTop: '24px',
    marginLeft: '28px',
  },
});

export const useInfoPaneItemRenameStyle = makeStyles({
  nameContentBox: {
    paddingBottom: '12px',
    paddingTop: '8px',
    position: 'relative',
  },
  addNameBox: {
    display: 'flex',
    alignItems: 'center',
  },
  addNameTitle: {
    fontFamily: 'Segoe UI',
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '32px',
    color: '#484644',
  },
  addNameIcon: {
    color: '#0078D4',
    cursor: 'pointer',
    marginLeft: '12px',
  },
  nameBox: {
    fontFamily: 'Segoe UI',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '19px',
    color: '#484644',
    maxWidth: '230px',
    ...shorthands.overflow('hidden'),
    textOverflow: 'ellipsis',
    wordBreak: 'break-all',
    whiteSpace: 'nowrap',
  },
  editNameBox: {
    display: 'flex',
    alignItems: 'center',
  },
  textField: {
    width: '300px',
    marginRight: '12px',
    '& input[type="text"]::placeholder ': {
      color: '#686868',
    },
  },
  completeIcon: {
    marginRight: '16px',
  },
});

export const useItemInfoCopyUrlStyles = makeStyles({
  contentItem: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Segoe UI',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '19px',
    marginTop: '8px',
  },
  contentName: {
    marginRight: '8px',
    width: '97px',
  },
  contentValue: {
    maxWidth: '230px',
    ...shorthands.overflow('hidden'),
    textOverflow: 'ellipsis',
    wordBreak: 'break-all',
    whiteSpace: 'nowrap',
  },
  copyUrl: {
    backgroundColor: 'transparent',
    fontFamily: 'Segoe UI',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#106ebe',
    ...shorthands.border('none'),
    ...shorthands.textDecoration('underline'),
  },
});

export const useItemInfoVideoQualityStyles = makeStyles({
  contentItem: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Segoe UI',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '19px',
    marginTop: '8px',
  },
  contentName: {
    marginRight: '8px',
    width: '97px',
  },
  contentValue: {
    maxWidth: '230px',
    ...shorthands.overflow('hidden'),
    textOverflow: 'ellipsis',
    wordBreak: 'break-all',
    whiteSpace: 'nowrap',
  },
  qualityBadge: {
    width: '50px',
    paddingBottom: '1px',
  },
});

export const usePerformanceContentStyles = makeStyles({
  dropdown: {
    minWidth: '0px',
    width: '160px',
    ...shorthands.margin('12px', '0px', '8px'),
  },
  metricBox: {
    height: '290px',
    position: 'relative',
  },
  loading: {
    opacity: '0.2',
  },
  spinner: {
    position: 'absolute',
    top: '0px',
  },
});

export const useExternalLinkStyles = makeStyles({
  externalButton: {
    marginTop: '24px',
    display: 'flex',
    ...shorthands.padding('6px', '12px'),
    ...shorthands.border('0px'),
    backgroundColor: 'transparent !important',
  },
  text: {
    marginLeft: '4px',
    fontFamily: 'Segoe UI',
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '32px',
  },
});

